import { useEffect, useRef, useState } from "react";
import React from "react";
import "./style.scss";
import { useWindowSize } from "@app/Helpers";
import card1 from "./img/Card1.png";
import card2 from "./img/Card2.png";
import card3 from "./img/Card3.png";
import { Swiper, SwiperSlide } from "swiper/react";

export default function SubscriptionCards({ hasSubscription }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  const caards = [card1, card2, card3];

  return (
    <div className="subscription-cards">
      <Swiper
        loop={false}
        className={"main-swiper"}
        spaceBetween={0}
        slidesPerView="auto"
      >
        {caards.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className={`slide-wrapper `}>
              <img alt={slide.id} src={slide} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
